import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { INVALID_TIME_MESSAGE } from '../../constants/messages';
import { EDay } from '../../types/workTime';
import { getTimeForTimezone, isDateInRange } from '../time';
import { parseTimeToDate } from '../time/parseTimeToDate';
import { validateTimeInput } from './validateTimeInput';
export var validateTime = function validateTime(time, workTime, timezoneDiff) {
  var formatValidation = validateTimeInput(time);
  if (formatValidation) {
    return formatValidation;
  }
  var callDate = parseTimeToDate(getTimeForTimezone(time, timezoneDiff));
  var overridesWorkingDays = workTime.overridesByDays.filter(function (item) {
    return item.isWorkingDay;
  });
  var workDay = {
    callFrom: workTime.callFrom,
    callTo: workTime.callTo,
    day: EDay.Monday,
    isWorkingDay: true
  };
  var workDays = [workDay].concat(_toConsumableArray(overridesWorkingDays));
  var isValidTime = workDays.some(function (_ref) {
    var callFrom = _ref.callFrom,
      callTo = _ref.callTo;
    var callFromDate = parseTimeToDate(callFrom);
    var callToDate = parseTimeToDate(callTo);
    if (callToDate.valueOf() < callFromDate.valueOf()) {
      callToDate.setHours(callToDate.getHours() + 24);
    }
    return isDateInRange(callDate, callFromDate, callToDate);
  });
  return isValidTime ? undefined : INVALID_TIME_MESSAGE;
};